import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = { class: "gfu-hero-banner__content gfu-homepage-wrapper" }
const _hoisted_3 = { class: "gfu-hero-banner__meta _tc--white" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h1 _tc--white" }
const _hoisted_5 = {
  key: 1,
  class: "_mt-2"
}
const _hoisted_6 = { class: "_mt-0" }
const _hoisted_7 = { class: "_whs-nw" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  class: "gfu-hero-banner__nav",
  "aria-label": "Slide navigation"
}
const _hoisted_10 = { class: "gfu-hero-banner__nav-viewport" }
const _hoisted_11 = ["aria-label", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "gfu-hero-banner__nav-buttons"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_label = _resolveComponent("base-label")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_currency_conversion_tooltip = _resolveComponent("currency-conversion-tooltip")
  const _component_display_currency_renderer = _resolveComponent("display-currency-renderer")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_skeleton_hero_banner = _resolveComponent("skeleton-hero-banner")
  const _component_touch = _resolveComponent("touch")

  return (_openBlock(), _createBlock(_component_touch, {
    onSwipeLeft: _cache[6] || (_cache[6] = $event => ($options.next(true, 'scroll-right'))),
    onSwipeRight: _cache[7] || (_cache[7] = $event => ($options.prev(true, 'scroll-left')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        ($options.isBannerVisible)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: "gfu-hero-banner",
              role: "region",
              "aria-label": "Hero banner",
              onMouseenter: _cache[2] || (_cache[2] = (...args) => ($options.pauseAutoplay && $options.pauseAutoplay(...args))),
              onMouseleave: _cache[3] || (_cache[3] = (...args) => ($options.resumeAutoplay && $options.resumeAutoplay(...args))),
              onFocusin: _cache[4] || (_cache[4] = (...args) => ($options.pauseAutoplay && $options.pauseAutoplay(...args))),
              onFocusout: _cache[5] || (_cache[5] = (...args) => ($options.resumeAutoplay && $options.resumeAutoplay(...args)))
            }, [
              _createElementVNode("a", {
                href: $options.currentSlide.url,
                target: $options.currentSlide.linkTarget,
                class: "_tc--white"
              }, [
                _createVNode(_TransitionGroup, {
                  name: "gfu-hero-fade",
                  mode: "out-in",
                  tag: "div"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, (slide, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: slide.id,
                        class: _normalizeClass(['gfu-hero-banner__slide',{ 'is-active': i === $data.currentIndex }]),
                        style: _normalizeStyle($options.bgStyle(slide.imageUrl))
                      }, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            (slide.labelText)
                              ? (_openBlock(), _createBlock(_component_base_label, {
                                  key: 0,
                                  class: "_mb-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(slide.labelText), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(slide.header), 1 /* TEXT */),
                            (slide.hasCustomContent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide.content, (line, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "_flex _gap-1 _ai-c _fw-b gfu-bt--b1 _mb-1"
                                    }, [
                                      _createVNode(_component_base_icon, {
                                        name: line.icon
                                      }, null, 8 /* PROPS */, ["name"]),
                                      _createElementVNode("p", _hoisted_6, [
                                        (line.amount !== undefined)
                                          ? (_openBlock(), _createBlock(_component_display_currency_renderer, {
                                              key: 0,
                                              amount: line.amount,
                                              "source-currency-id": line.sourceCurrencyId,
                                              "source-currency-symbol": line.sourceCurrencySymbol
                                            }, {
                                              default: _withCtx(({ formattedOriginalAmount, formattedNativeAmount, isConverted }) => [
                                                _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Homepage.HeroBannerFundedAmountLabel, formattedOriginalAmount)) + " ", 1 /* TEXT */),
                                                isConverted
                                                  ? (_openBlock(), _createBlock(_component_currency_conversion_tooltip, {
                                                      key: 0,
                                                      variant: "surface",
                                                      class: "_ml-1",
                                                      "icon-size": "sm",
                                                      "has-base-class": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_7, _toDisplayString(formattedNativeAmount), 1 /* TEXT */)
                                                      ]),
                                                      _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["amount", "source-currency-id", "source-currency-symbol"]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(line.content), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                      ])
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : (_openBlock(), _createElementBlock("p", {
                                  key: 2,
                                  class: "_mt-1",
                                  innerHTML: slide.content
                                }, null, 8 /* PROPS */, _hoisted_8))
                          ])
                        ])
                      ], 6 /* CLASS, STYLE */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ], 8 /* PROPS */, _hoisted_1),
              _createElementVNode("nav", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  ($options.areNavButtonsVisible)
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 0,
                        class: "gfu-hero-banner__nav-track",
                        style: _normalizeStyle($options.trackStyle)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, (slide, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: slide.id,
                            class: "gfu-hero-banner__nav-item"
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["gfu-hero-banner__thumb", { 'gfu-hero-banner__thumb--active': i === $data.currentIndex }]),
                              "aria-label": 'Show slide ' + slide.header,
                              onClick: $event => ($options.goTo(i))
                            }, [
                              _createVNode(_component_base_image, {
                                class: "gfu-hero-banner__thumb-image",
                                src: slide.thumbnailImageUrl,
                                alt: 'thumbnail: '+ slide.header
                              }, null, 8 /* PROPS */, ["src", "alt"])
                            ], 10 /* CLASS, PROPS */, _hoisted_11)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 4 /* STYLE */))
                    : _createCommentVNode("v-if", true)
                ]),
                (!$options.isLessThanL && $options.areNavButtonsVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_base_button, {
                        "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
                        theme: "white",
                        shape: "circle",
                        shadow: "tight",
                        class: "_ba-0",
                        onClick: _cache[0] || (_cache[0] = $event => ($options.prev(true, 'scroll-left'))),
                        "data-qa": "left-arrow-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "chevron-left",
                            class: "_tc--accent",
                            size: "lg"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["aria-label"]),
                      _createVNode(_component_base_button, {
                        "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
                        theme: "white",
                        shape: "circle",
                        shadow: "tight",
                        class: "_ba-0",
                        onClick: _cache[1] || (_cache[1] = $event => ($options.next(true, 'scroll-right'))),
                        "data-qa": "right-arrow-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "chevron-right",
                            class: "_tc--accent",
                            size: "lg"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["aria-label"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 32 /* NEED_HYDRATION */))
          : (_openBlock(), _createBlock(_component_skeleton_hero_banner, { key: 1 }))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}